import React from 'react';
import VenueImageGallery from './ImageGallery/venueImageGallery';
import DesktopAllComponent from './desktop-all-component';
import {connect} from 'react-redux';
import BackButton from './backButton';


class Detail extends React.Component{
  constructor(props) {
    super(props);
    this.state = {show: false, items: [] };
  }



  render(){


      var name = this.props.OfferDetails.offerName;
      var shareMsg = this.props.OfferDetails.shareMsg;
      var coupon = this.props.OfferDetails.coupon;
      var sports =  this.props.OfferDetails.sports;
      var offerContent = this.props.OfferDetails.offerContent;
      var offerType = this.props.OfferDetails.offerType;


      try{


      }catch(err){

      }

    return (
      <div>
        {/*<div className="relative_position">*/}
         {/*{ this.props.viewport ? <BackButton /> : <span/> }*/}

           {/*<VenueImageGallery imageUrl= {this.props.OfferDetails.imageUrl}  viewport = {this.props.viewport} name={name}/>*/}
        {/*</div>*/}

         <DesktopAllComponent
            offerName = {name}
            shareMsg = {shareMsg}
            coupon={coupon}
            sports={sports}
            offerContent={offerContent}
            offerType={offerType}
            imageUrl= {this.props.OfferDetails.imageUrl}
         />

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    OfferDetails : state.OfferDetails,
    viewport :state.ViewPort
  };
}


export default connect(mapStateToProps)(Detail);



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/all-components.js